module.exports = __webpack_public_path__ + "static/media/reward-card-cost-gem.deb31203.svg";